import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { httpsCallable } from "firebase/functions";
import { useFunctions, useUser } from "reactfire";
import { Button, Spinner } from "react-bootstrap";
import { HiExternalLink } from "react-icons/hi";

const InspectionReport = ({ vin }) => {
  const [loadingInspectionReport, setLoadingInspectionReport] = useState(false);
  const [inspectionReport, setInspectionReport] = useState(null);
  const [error, setError] = useState(null);

  const functions = useFunctions();

  const getInspectionReport = async (vin) => {
    if (vin.length < 16) {
      toast.error("Something went wrong, could not retrieve inspection report");
      console.log("VIN missing");
      return;
    }
    try {
      setLoadingInspectionReport(true);
      console.log("Attempting to retrieve inspection report");
      const payload = { vin };
      var getSugarCRMInspectionReport = httpsCallable(
        functions,
        "getSugarCRMInspectionReport"
      );
      // var getSugarCRMInspectionReport = firebase
      //   .functions()
      //   .httpsCallable("getSugarCRMInspectionReport");
      setInspectionReport(null);
      await getSugarCRMInspectionReport(payload).then((r) => {
        console.log("getSugarCRMInspectionReport", r);
        if (r?.data === false) {
          toast.error("Not authorised");
          return;
        }
        if (r?.error) {
          toast.error(r.error[0].message);
          return;
        }
        if (r?.data?.length > 0) {
          toast.success(`Found reports`);
        } else {
          toast.error("No reports found");
          setError("No reports found");
          setInspectionReport(null);
        }

        setInspectionReport(r.data);
      });
    } catch (e) {
      toast.error(e.message);
    }
    setLoadingInspectionReport(false);
  };

  const returnUrl = (description, name, attachments) => {
    // Is this a URL?
    if (description?.startsWith("http")) {
      return (
        <a href={description} target="_blank" rel="noopener noreferrer">
          {name} <HiExternalLink />
        </a>
      );
    } else {
      // Loop through attachments
      if (attachments && attachments.length > 0) {
        for (let i = 0; i < attachments.length; i++) {
          const attachment = attachments[i];
          if (attachment?.url) {
            return (
              <a
                href={attachment.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {attachment.name} <HiExternalLink />
              </a>
            );
          }
        }
      }
      return <span>No valid URL found</span>;
    }
  };

  return (
    <div className="mb-3 card p-3">
      <p>
        <strong>Inspection Report (from SugarCRM)</strong>
        <br />
        Click the button below to retrieve the inspection report for this VIN.
        <br />
        <strong>Note:</strong> This may take a few seconds.
        <br />
        <Button
          size="sm"
          disabled={loadingInspectionReport}
          className="mt-2"
          variant="outline-secondary"
          onClick={() => getInspectionReport(vin)}
        >
          Get Inspection Report
        </Button>
      </p>
      {error && <p className="text-danger">{error}</p>}
      <Toaster />

      {loadingInspectionReport && <Spinner animation="border" size="sm" />}
      {inspectionReport && (
        <div>
          {returnUrl(
            inspectionReport[0]?.description,
            inspectionReport[0]?.name,
            inspectionReport[0]?.attachment_list?.records
          )}
          <pre>{JSON.stringify(inspectionReport, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};
export default InspectionReport;
